// This file will hopefully help build the correct URL.

import { URLSearchParamsInit } from "react-router-dom";
import { Tag } from "../components/search/Tags";
import * as constants from "../store/Constants";
import { Recipe } from "../store/Recipe";

export const getOptions = (column: string, index: Recipe[]) => {
  return [
    ...new Set( //set removes the duplicates
      index
        .flatMap((recipe) => recipe[column]?.split(",")) // some attributes have multiple elements split by a comma, split will break them and flat in flatmap will flatten them out
        .map((recipe) => recipe?.trim()) // trim off excess whitespace (also important for the Set)
    ),
  ]
    .sort() // sort alphebetically
    .filter((recipe) => recipe); // remove all the empty strings
};

interface getAllOptionsInterface {
  index: Recipe[];
}

export const getAllOptions = (props: getAllOptionsInterface) => {
  const allOptions = [
    ...new Set(
      constants.KeywordQueryOptions.flatMap((attribute) =>
        getOptions(attribute, props.index)
      )
    ),
  ];
  // We also need to split up each multi-word attribute (ex: "olive oil" becomes "olive", "oil", and "olive oil").
  const allOptionsWithNameSplit = [
    ...new Set(
      allOptions
        .flatMap((attribute) => { 
          return [...attribute?.toLowerCase().split(" "), attribute];
        })
        .sort(),
    ),
  ];
  return allOptionsWithNameSplit;
};

interface getCurrentQueryInterface {
  column: string;
  query: URLSearchParams;
}

export const getCurrentQuery = (props: getCurrentQueryInterface) => {
  return props.query.getAll(props.column).map((name) => {
    return {
      label: name,
    } as Tag;
  });
};

interface updateQueryInterface {
  column: string;
  query: URLSearchParams;
  tags: Tag[];
  setQuery: (newParams: URLSearchParamsInit) => void;
}

// This will return a new set of search params.
export const updateQuery = (props: updateQueryInterface) => {
  // We want to preserve the other pieces of the query.
  // Let's first remove the previous query.
  props.query.delete(props.column);
  // And then add it back, but with the new content.
  for (let tag of props.tags) {
    props.query.append(props.column, tag.label);
  }
  // Now actually set the query.
  props.setQuery(props.query);
};
